module.exports = __webpack_public_path__ + "img/cli_07.38004420.png";